import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import RankingSection from './components/RankingSection';
import LatestSection from './components/LatestSection';
import { siteInfo, categories } from '@/mocks/comics';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '广州',
      addressRegion: '广东',
      addressCountry: 'CN',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteInfo.url}/category/hanman?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '女神漫画 - 首页',
    description: siteInfo.description,
    url: siteInfo.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
    },
    about: {
      '@type': 'Thing',
      name: '漫画在线阅读',
      description: '提供韩漫、日漫、国漫全集免费在线阅读服务',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            organizationSchema,
            websiteSchema,
            webpageSchema,
          ]),
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />

        <section className="py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 mb-8">
              <div className="w-1 h-6 bg-primary-500 rounded-full" />
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                热门推荐
              </h2>
            </div>
          </div>
          <RankingSection type="hot" />
        </section>

        <LatestSection />

        <RankingSection type="rating" />
      </main>
      <Footer />
    </>
  );
}